import React, { useState, useRef } from "react";
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from 'react-icons/md';
import '../css/customButtonSelectOptionView.css';
import CustomButtonSelectOption from "./CustomButtonSelectOption";
import { useSelector } from 'react-redux';

const CustomButtonSelectOptionView = (props) => {
    const {
        options = [],
        optionText = [],
        onOptionChange = '',
    } = props;

    const [selectedOption, setSelectedOption] = useState(options[0]);
    const [currentIndex, setCurrentIndex] = useState(0);
    const containerRef = useRef(null);
    const isStatusCarteira = useSelector((state) => state.onboardingUserData.isStatusCarteira);

    const handleLeft = () => {
        if (currentIndex > 0) { 
            const newIndex = currentIndex - 1;
            setCurrentIndex(newIndex);
            setSelectedOption(options[newIndex]);
            onOptionChange(options[newIndex]);
            scrollToOption(newIndex);
        }
    };

    const handleRight = () => {
        if (currentIndex < options.length - 1) { 
            const newIndex = currentIndex + 1;
            setCurrentIndex(newIndex);
            setSelectedOption(options[newIndex]);
            onOptionChange(options[newIndex]);
            scrollToOption(newIndex);
        }
    };

    const scrollToOption = (index) => {
        const container = containerRef.current;
        if (container) {
            const selectedElement = container.children[index];
            if (selectedElement) {
                container.scrollTo({
                    left: selectedElement.offsetLeft - (container.offsetWidth - selectedElement.offsetWidth) / 2,
                    behavior: 'smooth',
                });
            }
        }
    };

    const handleOptionClick = (option) => {
        const newIndex = options.indexOf(option);
        setCurrentIndex(newIndex);
        setSelectedOption(option);
        onOptionChange(option);
        scrollToOption(newIndex);
    };

    return (
        <div className='swithSelectorViewContainerCustomButtonSelectOptionViewMovile'>
            { currentIndex > 0 &&
                <button onClick={handleLeft} className='btnArrowViewCustomButtonSelectOptionViewMovile'>
                    <MdKeyboardArrowLeft className='arrowViewCustomButtonSelectOptionViewMovile' />
                </button>
            }
            <div className='swithSelectorContainerCustomButtonSelectOptionViewMobile' ref={containerRef}>
                {options.map((option, index) => (
                    <CustomButtonSelectOption
                        key={option}
                        text={optionText[index] || option}
                        onPress={() => handleOptionClick(option)}
                        isActive={selectedOption === option}
                        enabled={(option === 'ofertas' && isStatusCarteira ===  '2') || (option === 'convidar-amigos' && isStatusCarteira ===  '2')}
                    />
                ))}
            </div>
            { currentIndex < options.length - 1 &&
                <button 
                    onClick={handleRight} 
                    className='btnArrowViewRightCustomButtonSelectOptionViewMovile'
                    disabled={isStatusCarteira ===  '2'}
                    >
                    <MdKeyboardArrowRight className='arrowViewCustomButtonSelectOptionViewMovile' />
                </button>
            }
        </div>
    );
};

export default CustomButtonSelectOptionView;
